import { z } from "zod";
import type { BestillingContextDataType } from "../context";

export const oppsummeringFormSchema = z
  .object({
    vilkårAkseptert: z.boolean().nullable(),
  })
  .refine((val) => val.vilkårAkseptert === true, {
    message: "pages.oppsummering.felt.vilkårAkseptert.vilkår-må-aksepteres",
  });

export type oppsummeringFormValues = z.infer<typeof oppsummeringFormSchema>;

export function getDefaultOppsummeringFormValues(
  bestilling: BestillingContextDataType,
): oppsummeringFormValues {
  return {
    vilkårAkseptert: bestilling.vilkårAkseptert || false,
  };
}
